import React from "react";

const Modal = ({ children, onClose }) => (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-lg relative">
      <button onClick={onClose} className="absolute top-2 right-2 text-xl">
        &times;
      </button>
      {children}
    </div>
  </div>
);

export default Modal;